import { Grid, Row, Col, Tabs, Tab } from "react-bootstrap";
import AlertFlag from "../AlertFlag";
import AlertModal from "../AlertModal";
import FailedToLoadAlert from "../FailedToLoadAlert";
import ImageSetUploader from "../ImageSetUploader";
import ComboInfoTab from "../ComboInfoTab";
import Loader from "../Loader";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import * as combos from "../../lib/api/combos";
import * as imageTypes from "../../enums/imageType";
import PropTypes from "prop-types";
import logger from "../../lib/logger";

const styles = StyleSheet.create({
    tabWrapper: {
        marginTop: 20,
    },
});

const strings = {
    loading: "Loading",
    titleSuffix: "| Habit CMS",
    combo: "Combo",
    info: "Info",
    images: "Images",
    isolatedImage128: "Rebrand Isolated Image 128",
    isolatedImage352: "Rebrand Isolated Image 352",
    isolatedImage1152: "Rebrand Isolated Image 1152",
    modifiers: "Modifiers",
    edit: "Edit",
    missingIsolatedImages128: "Missing Rebrand Isolated Image 128",
    missingIsolatedImages352: "Missing Rebrand Isolated Image 352",
    missingIsolatedImages1152: "Missing Rebrand Isolated Image 1152",
    generalErrorMsg: "There was an error with your request.",
};

export default class ComboPage extends PureComponent {
    static propTypes = {
        match: PropTypes.object.isRequired,
    };

    state = {
        combo: null,
        loading: true,
        showAlertModal: false,
        errorMsg: "",
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = `${strings.loading} ${strings.titleSuffix}`;
        combos
            .getCombo(this.props.match.params.comboId)
            .then(resp => {
                if (this._isMounted) {
                    this.setState({ combo: resp, loading: false });
                    document.title = `${resp.name} ${strings.titleSuffix}`;
                }
            })
            .catch(this._handleRequestException);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _handleUploadImage = (imageType, image, crop) => {
        return combos
            .addImage(this.state.combo.id, imageType, image, crop)
            .then(images => {
                if (this._isMounted) {
                    this.setState({
                        combo: {
                            ...this.state.combo,
                            isolatedImages128:
                                imageType === imageTypes.Isolated128
                                    ? images
                                    : this.state.combo.isolatedImages128,
                            isolatedImages352:
                                imageType === imageTypes.Isolated352
                                    ? images
                                    : this.state.combo.isolatedImages352,
                            isolatedImages1152:
                                imageType === imageTypes.Isolated1152
                                    ? images
                                    : this.state.combo.isolatedImages1152,
                        },
                    });
                }
                return images;
            })
            .catch(this._handleRequestException);
    };

    _handleSaveInfo = combo => {
        if (this._isMounted) {
            this.setState({ combo });
        }
    };

    _handleRequestException = e => {
        logger.warn(e);
        let errorMsg = strings.generalErrorMsg;
        if (
            e &&
            e.response &&
            e.response.status === 400 &&
            e.response.data &&
            typeof e.response.data === "string"
        ) {
            errorMsg = e.response.data;
        }
        if (this._isMounted) {
            this.setState({ loading: false, showAlertModal: true, errorMsg });
        }
    }

    _closeAlertModal = () => this.setState({ showAlertModal: false, errorMsg: "" });

    render() {
        if (this.state.loading) {
            return <Loader />;
        } else if (!this.state.combo) {
            return <FailedToLoadAlert type={strings.combo} />;
        }
        const combo = this.state.combo;
        return (
            <>
                <Grid>
                    <Row bsClass="m-t">
                        <Col md={6}>
                            <h4>{combo.name}</h4>
                        </Col>
                        <Col md={6}>
                            {!this.state.combo.isolatedImages128 ||
                            !this.state.combo.isolatedImages128.length ? (
                                <AlertFlag label={strings.missingIsolatedImages128} />
                            ) : null}
                            {!this.state.combo.isolatedImages352 ||
                            !this.state.combo.isolatedImages352.length ? (
                                <AlertFlag label={strings.missingIsolatedImages352} />
                            ) : null}
                            {!this.state.combo.isolatedImages1152 ||
                            !this.state.combo.isolatedImages1152.length ? (
                                <AlertFlag label={strings.missingIsolatedImages1152} />
                            ) : null}
                        </Col>
                    </Row>
                    <Row bsClass="m-t">
                        <Col md={12}>
                            <div className={css(styles.tabWrapper)}>
                                <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                                    <Tab eventKey={1} title={strings.info}>
                                        <ComboInfoTab
                                            key={combo.id}
                                            initialCombo={combo}
                                            onSave={this._handleSaveInfo}
                                        />
                                    </Tab>
                                    <Tab eventKey={2} title={strings.images}>
                                        <Row>
                                            <Col md={4}>
                                                <ImageSetUploader
                                                    label={strings.isolatedImage128}
                                                    images={combo ? combo.isolatedImages128 : null}
                                                    onSubmit={this._handleUploadImage.bind(
                                                        this,
                                                        imageTypes.Isolated128,
                                                    )}
                                                    minWidth={128}
                                                    minHeight={92}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <ImageSetUploader
                                                    label={strings.isolatedImage352}
                                                    images={combo ? combo.isolatedImages352 : null}
                                                    onSubmit={this._handleUploadImage.bind(
                                                        this,
                                                        imageTypes.Isolated352,
                                                    )}
                                                    minWidth={352}
                                                    minHeight={253}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <ImageSetUploader
                                                    label={strings.isolatedImage1152}
                                                    images={combo ? combo.isolatedImages1152 : null}
                                                    onSubmit={this._handleUploadImage.bind(
                                                        this,
                                                        imageTypes.Isolated1152,
                                                    )}
                                                    minWidth={1152}
                                                    minHeight={828}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                </Grid>
                <AlertModal show={this.state.showAlertModal}
                    alertMessage={this.state.errorMsg}
                    handleClose={this._closeAlertModal}
                />
            </>
        );
    }
}
